module.exports = [{
      plugin: require('/Users/chrisguevara/Projects/personal-sites/blog/node_modules/gatsby-mdx/gatsby-browser'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":590}},{"resolve":"gatsby-remark-responsive-iframe","options":{"wrapperStyle":"margin-bottom: 1.0725rem"}},{"resolve":"gatsby-remark-copy-linked-files"},{"resolve":"gatsby-remark-smartypants"}]},
    },{
      plugin: require('/Users/chrisguevara/Projects/personal-sites/blog/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/chrisguevara/Projects/personal-sites/blog/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/chrisguevara/Projects/personal-sites/blog/node_modules/gatsby-plugin-typography/gatsby-browser'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/chrisguevara/Projects/personal-sites/blog/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
